import React from 'react';
import {Create, SimpleForm, TextInput} from 'react-admin'
import {regex} from 'react-admin';
import InputAdornment from '@material-ui/core/InputAdornment';
import validation from './validation';
import {withTranslation} from 'react-i18next';

const validateUrl = regex(/https:\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/\S*)?/);

const formatEmail = (value) => {
    if (!value) return '';
    return value.replace(/@mynuma\.io$/, '');
};

const parseEmail = (value) => {
    if (!value) return null;
    return value.replace(/@mynuma\.io$/, '');
};

const ReceiverCreate = ({t, ...props}) => (
    <Create {...props} title={t('Create sender')}>
        <SimpleForm redirect={'/receivers'} validate={validation}>
            <TextInput source={'name'} label={t('Name')} autoFocus fullWidth/>
            <TextInput source={'url'} label={t('Url')} validate={validateUrl} fullWidth/>
            <TextInput
                source={'email'}
                label={t('Email')}
                format={formatEmail}
                parse={parseEmail}
                helperText={t('Leave empty to auto-generate')}
                InputProps={{
                    endAdornment: <InputAdornment position="end">@mynuma.io</InputAdornment>,
                }}
                fullWidth
            />
        </SimpleForm>
    </Create>
);


export default withTranslation()(ReceiverCreate);